// extracted by mini-css-extract-plugin
export default {"request-confirmation":"RequestConfirmation_request-confirmation__Bakne","body":"RequestConfirmation_body__NUldE","home-link":"RequestConfirmation_home-link__MemU-"};